<template>
  <v-container class="card">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h4 class="card-header">
          Please enter your 8-character offer code.
        </h4>
      </v-col>
    </v-row>
    <v-form
      id="offerCodeForm"
      ref="offerCodeForm"
      v-model="isOfferValid"
      class="offer-code-form"
      @submit.prevent="submit"
      @input="onChange"
    >
      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-text-field
            id="offer-code-input"
            v-model="upperCode"
            v-mask="offerCodeMask"
            :name="'offer-code-input'"
            class="offer_code_input input"
            :placeholder="'XXX-XX-XXX'"
            outlined
            :rules="rules.offerCode"
            hide-details="auto"
            required
          >
            <template v-if="form.offerCode != ''" v-slot:append>
              <v-icon v-if="invalidOfferCode || !isOfferValid" class="mdi mdi-close"/>
              <v-icon v-else class="mdi mdi-check"/>
            </template>
          </v-text-field>
          <span v-if="invalidOfferCode">
            <a v-if="loggedIn" href="/my_account/summary"  class="submit-error">
              {{ invalidOfferCodeMessage }}
            </a>
            <p v-else class="submit-error">
              {{ invalidOfferCodeMessage }}
            </p>
          </span>
        </v-col>
      </v-row>
    </v-form>
    <v-row justify="center">
      <v-col cols="12" md="8" align="center">
        <v-btn
          form="offerCodeForm"
          type="submit"
          x-large
          class="card-btn"
          color="#007EB1"
          :disabled="invalidOfferCode || !isOfferValid || submitPressed"
          :ripple="false"
        >
          Look up Offer Code
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="8" align="center">
        <a href="https://www.netcredit.com/apply" class="link">
          Check your eligibility without an offer code.
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import router from './DMOfferCodeRouter';

  export default {
    name: 'OfferCode',
    data() {
      return {
        form: { offerCode: '', },

        rules: {
          offerCode: [
            (val) => !!val || 'Code is required',
            (val) => val && (val.length === 10 || val.length === 11),
          ],
        },

        isOfferValid: false,
        invalidOfferCodeMessage: 'This offer code is invalid.',
        submitPressed: false,
      };
    },

    computed: {
      ...mapGetters(['invalidOfferCode', 'loggedIn']),

      upperCode: {
        get() {
          return this.form.offerCode;
        },
        set(code) {
          this.form.offerCode = code.toUpperCase();
        },
      },

      offerCodeMask() {
        return this.form.offerCode.length <= 10 ? 'NNN-NN-NNN' : 'NNN-NNN-NNN';
      }
    },

    methods: {
      ...mapActions([
        'addOfferCode',
        'fetchCustomerOfferAndAddToState',
        'resetOfferCodeError',
      ]),

      async submit() {
        if (this.submitPressed) { return };
        this.submitPressed = true;
        await this.addOfferCode(this.form.offerCode);
        await this.fetchCustomerOfferAndAddToState();

        if (!this.invalidOfferCode) {
          if (this.loggedIn) {
            window.location.replace(
              window.location.origin + '/my_account/summary');
          } else {
            router.push('/verify');
          }
        }
        this.submitPressed = false;
      },
      async onChange() {
        await this.resetOfferCodeError();
      },
    },
  };
</script>

<style scoped lang="scss">
  .card {
    background: #ffffff;
    position: relative;

    @media (max-width: 768px) {
      box-shadow: 0px;
      padding: 15px;
    }

    @media (min-width: 768px) {
      box-shadow: 0px 2px 3px #00000029;
      padding: 40px;
    }

    .offer-code-form {
      ::v-deep .v-input--has-state .v-input__slot{
        border: 1px solid #DB2435 !important;
      }
      ::v-deep .error--text{
       color: #DB2435 !important;
       caret-color: #333333 !important;
      }
    }

    .card-header {
      color: #333333;
      font-size: 18px;
      font: normal normal bold 18px/25px Open Sans;
      letter-spacing: 0px;
      opacity: 1;
      align-items: left;

      @media (max-width: 768px) {
        font: normal normal bold 16px/25px Open Sans;
      }
    }

    .input {
      font: normal normal normal 16px/28px Open Sans;
      letter-spacing: 0px;
      padding: 20px 8px 5px 8px;
      color: #333333;
      opacity: 1;

      .v-text-field--outlined.v-input--has-state ::v-deep fieldset {
        border: 1px solid #db2435 !important;
      }
      .v-text-field--outlined.v-input--is-focused ::v-deep fieldset {
        border: 1px solid #016c98;
      }
      ::v-deep .v-input__slot {
        fieldset {
          border: 1px solid #a9a9a9;
        }
        &:hover,
        &:focus {
          box-shadow: 0 0 8px #007eb1;
        }
      }
    }

    .v-placeholder {
      color: #6c6c6c;
      text-align: left;
      font: normal normal normal 18px/28px Open Sans;
      letter-spacing: 0px;
      opacity: 1;
    }

    .card-btn {
      color: #ffffff;
      font: normal normal 600 26px/37px Open Sans;
      border-radius: 5px;
      opacity: 1;
      background: #007eb1;
      border: 2px solid #016c98;

      ::v-deep .v-btn__content {
        letter-spacing: 0px;
        text-align: center;
        text-transform: none;
        padding: 0px 33px;
      }

      &:hover,
      &:focus {
        background: #016c98;
        border: 2px solid #016c98;
      }

      &:active {
        box-shadow: 0 0 8px #007eb1;
        background-color: #007eb1 0% 0% no-repeat padding-box;
        border: 2px solid #007eb1;
        color: #ffffff;
      }

      &:disabled {
        background-color: #d7d7d7 0% 0% no-repeat padding-box;
        border: 2px solid #d7d7d7;
        color: #333333 !important;
      }

      @media (max-width: 768px) {
        padding: 0px;
        font: normal normal 600 20px/28px Open Sans;
      }
    }

    .link {
      color: #007eb1;
      font: normal normal bold 18px/25px Open Sans;
      letter-spacing: 0px;
      border-radius: 5px;
      opacity: 1;
      
      @media (max-width: 768px) {
        font: normal normal bold 16px/25px Open Sans;
      }
    }

    .submit-error {
      font-size: 12px;
      color: #DB2435 !important;
      caret-color: #DB2435 !important;
      text-align: right !important;
      word-break: break-word;
    }
    ::v-deep .v-messages__message {
      text-align: right;
    }

    .mdi-close:before{
      color: #DB2435;
    }
    .mdi-check:before {
      color: #4EBB85;
    }
  }
</style>
